import { render, staticRenderFns } from "./button-call-to-action.vue?vue&type=template&id=335b044d&scoped=true&"
import script from "./button-call-to-action.vue?vue&type=script&lang=js&"
export * from "./button-call-to-action.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "335b044d",
  null
  
)

export default component.exports